import React from "react";
import { Flex, Text } from "@jsq/ds/core";
import { RowItem, TypedAGGridCellRenderParams } from "../types";
import { flexStyle } from "./style_vanilla.css";

interface NameRendererProps {
  params: TypedAGGridCellRenderParams<RowItem>;
}

export const NameRenderer: React.FC<NameRendererProps> = ({ params }) => {
  return (
    <Flex flexDirection="column" className={flexStyle}>
      <Text>{params.data.name}</Text>
      <Text variant="secondary-sm">{params.data.type}</Text>
    </Flex>
  );
};
